import { RootState } from '../../store';

export const getIdToDeleteSelector = (state: RootState) => state?.ruleReducer?.ruleIdToDelete;
